import template from '../../../../views/campaign/partials/campaign-settings.html';

export default class campaignSettings {
    constructor() {
        return {
            restrict: 'E',
            template: template,
            scope: {
               editCtrl: '='
            },
            controller: ['$scope', '$element', '$attrs', (scope, element, attr) => {
                scope.deactivateBlockStatistics = () => {
                    scope.editCtrl.dispatcher['block_statistics'] = false;

                    scope.editCtrl.save().then(() => {
                        scope.editCtrl.setStatus('abTest')
                    });
                };

                scope.activateBlockTracking = () => {
                    scope.editCtrl.dispatcher['block_statistics'] = true;

                    scope.editCtrl.save().then(() => {
                        scope.editCtrl.setStatus('abTest')
                    });
                };
            }]
        }
    }
}
